import { NgModule } from '@angular/core';
import { TableDataService } from "./table-data.service";
import { CommonModule } from "@angular/common";
import { LabelModule } from "libraries/service/label/label.module";

@NgModule({
 imports: [
     CommonModule,
     LabelModule,
 ],
 providers: [
     TableDataService
 ],
})
export class TableDataModule { }
